import { render } from "./MainInfoComp.vue?vue&type=template&id=da4cea3e&scoped=true"
import script from "./MainInfoComp.vue?vue&type=script&lang=js"
export * from "./MainInfoComp.vue?vue&type=script&lang=js"

import "./MainInfoComp.vue?vue&type=style&index=0&id=da4cea3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da4cea3e"]])

export default __exports__